export default angular
  .module('st.ClientAccess', ['st.Core', 'angular-cache'])
  .factory('ClientAccess', function (dateTimeService) {
    ClientAccess.Blank = function () {
      return ClientAccess.Build({
        id: '',
        idOrganization: '',
        idContact: '',
        idTicket: '',
        url: '',
        pin: '',
        timeStamp: dateTimeService.epoch(),
        isAuthenticated: false,
        isActive: true
      });
    };
    ClientAccess.Build = function (data) {
      return new ClientAccess(
        data.id,
        data.idOrganization,
        data.idContact,
        data.idTicket,
        data.url,
        data.pin,
        data.timeStamp ? data.timeStamp : dateTimeService.epoch(),
        data.isAuthenticated,
        data.isActive
      );
    };
    function ClientAccess(
      id,
      idOrganization,
      idContact,
      idTicket,
      url,
      pin,
      timeStamp,
      isAuthenticated,
      isActive
    ) {
      this.id = id;
      this.docType = 'clientAccess';
      this.idOrganization = idOrganization;
      this.idContact = idContact;
      this.idTicket = idTicket;
      this.url = url;
      this.pin = pin;
      this.isAuthenticated = isAuthenticated;
      this.timeStamp = timeStamp;
      this.isActive = isActive;
    }
    return ClientAccess;
  })
  .service('clientAccessService', (ClientAccess, dataService) => ({
    createClientAccess: (doc) => dataService.createDocument(ClientAccess.Build(doc)),
    readClientAccess: (doc) => dataService.readDocument(ClientAccess.Build(doc)),
    updateClientAccess: (doc) => dataService.updateDocument(ClientAccess.Build(doc)),
    deleteClientAccess: (doc) => dataService.deleteDocument(ClientAccess.Build(doc))
  }))
  .service(
    'clientAccessService',
    ($http, $rootScope, CacheFactory, dataService, ClientAccess, CLIENT_ACCESS) => ({
      grant: (params) =>
        dataService.apiRequest(
          null,
          null,
          params?.ignoreCache === true,
          null,
          $http.post,
          CLIENT_ACCESS.API.GRANT,
          { params },
          null,
          true
        ),
      hasAccess: (params) =>
        dataService.apiRequest(
          null,
          null,
          params?.ignoreCache === true,
          null,
          $http.get,
          CLIENT_ACCESS.API.HAS_ACCESS,
          { params }
        ),
      interview: (params) =>
        dataService.apiRequest(
          null,
          null,
          params?.ignoreCache === true,
          null,
          $http.post,
          CLIENT_ACCESS.API.INTERVIEW,
          { params },
          null,
          true
        ),
      revoke: (params) =>
        dataService.apiRequest(
          null,
          null,
          params?.ignoreCache === true,
          null,
          $http.post,
          CLIENT_ACCESS.API.REVOKE,
          { params },
          null,
          true
        )
    })
  )
  .constant('CLIENT_ACCESS', {
    API: {
      GRANT: '/api/v1/client-access/grant/',
      HAS_ACCESS: '/api/v1/client-access/has-access/',
      INTERVIEW: '/api/v1/client-access/interview/',
      REVOKE: '/api/v1/client-access/revoke/'
    }
  });
